<div class="container-fluid cw-background">
  <mat-card class="mat-elevation-z8 my-3">
    <mat-card-title class="title-page">Internal Providers List</mat-card-title>
    <button
      *ngIf="currentUser.hasRight(['admin']) && currentUser.isGlobal()"
      mat-fab
      class="create"
      color="accent"
      (click)="onAddInternalProvider()"
    >
      <mat-icon>add</mat-icon>
    </button>
    <mat-card-content class="mt-12">
      <app-data-table
        *ngIf="tableConfig"
        [config]="tableConfig"
        (getData)="internalProviderTableService.getInternalProviders($event)"
        (updateData)="internalProviderTableService.update($event)"
      ></app-data-table>
    </mat-card-content>
  </mat-card>
</div>
